/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useState, useEffect, useCallback, useContext, useRef,
} from 'react';
import moment from 'moment';
import { motion } from 'framer-motion';
import { Link, useParams } from 'react-router-dom';
import { PriceHandler } from '../../../../redux/helper/CamelCase';
import { distributorService } from '../../../../service/distributor.service';
import IndentListSkeleton from '../../IndentReport/indentlistSkeleton';
import HeaderContext from '../../../../Components/Context/HeaderContext';
import ViewCustomerFilterModal from './ViewCustomerFilterModal';
import Pagination from '../../../../Components/Pagination';
import EmptyScreen from '../../../../Components/GlobalEmplyPage';

function ViewCustomerOutstandingInvoice() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const { id } = useParams();
    const [particularCustomerList, setParticularCustomerList] = useState([]);
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [viewFilterModal, setViewFilterModal] = useState(false);
    const [sortType, setsortType] = useState('gst_invoice_date+desc');
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const [emptyData, setEmptyData] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [viewCustomerFilter, setViewCustomerFilter] = useState({
        gst_invoice_date: [],
        ar_date: [],
    });

    const [selected, setselected] = useState({
        gst_start_date: '',
        gst_end_date: '',
        ar_start_date: '',
        ar_end_date: '',
    });

    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage, sortType]);

    const handleViewCustomer = useCallback((() => {
        distributorService.MISViewCustomerWiseOutstandingReport(id, currentPage, debouncedSearch, sortType, filterValue).then((response) => {
            if (response.error === false && response.data.success_status) {
                if (response.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setParticularCustomerList(response.data.data);
                setCurrentPage(response.data.current_page);
                setTotalPage(response.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }), [currentPage, sortType, filterValue, debouncedSearch]);

    const handleFilter = (filterUrl) => {
        if (filterValue !== filterUrl) {
            setLoading(true);
            // setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleExport = useCallback((() => {
        distributorService.MISViewCustomerWiseOutstandingReport(id, currentPage, debouncedSearch, sortType, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleViewCustomer();
    }, [handleViewCustomer]);

    return (
        <div className="py-6 pr-[18px] main-screen">
            <div className="flex justify-between pb-[18px]">
                <div className="flex items-center">
                    <Link to="/mis-reports/customer-wise-outstanding-report">
                        <img src="/images/arrow-back-fill.svg" alt="icon" />
                    </Link>
                    <h5 className="text-xs4 font-normal text-[#555259] ml-3">Outstanding Invoice Details Report</h5>
                </div>
                <div className="flex">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setViewFilterModal(true)}

                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px] pr-[15px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[100px] ${exportClick === true ? 'show' : 'hidden'} absolute  bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf-converter')}
                                >
                                    PDF

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <IndentListSkeleton /> : (
                <div>
                    {particularCustomerList.length > 0 && (
                        <div
                            className="overflow-auto dropdown-menu  pb-7 relative z-10"
                            style={{ height: 'calc(100vh - 325px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="sticky top-0 left-0 z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-1 px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                Customer Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-1 px-7 min-w-[168px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Customer Code
                                            </span>
                                        </th>
                                        <th scope="col" className="py-1 px-7 min-w-[250px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                GST Invoice No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-1 px-7 min-w-[250px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                GST Invoice Date
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'gst_invoice_date+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'gst_invoice_date+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'gst_invoice_date+asc') {
                                                                setsortType('gst_invoice_date+desc');
                                                            } else if (sortType === 'gst_invoice_date+desc') {
                                                                setsortType('gst_invoice_date+asc');
                                                            } else {
                                                                setsortType('gst_invoice_date+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-1 px-7 min-w-[168px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Unit
                                            </span>
                                        </th>
                                        <th scope="col" className="py-1 px-7 min-w-[168px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Class
                                            </span>
                                        </th>
                                        <th scope="col" className="py-1 px-7 min-w-[168px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                AR Number
                                            </span>
                                        </th>
                                        <th scope="col" className="py-1 px-7 min-w-[240px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                AR Date
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'TRX_DATE+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'TRX_DATE+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'TRX_DATE+asc') {
                                                                setsortType('TRX_DATE+desc');
                                                            } else if (sortType === 'TRX_DATE+desc') {
                                                                setsortType('TRX_DATE+asc');
                                                            } else {
                                                                setsortType('TRX_DATE+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-1 px-7 min-w-[260px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Description
                                            </span>
                                        </th>
                                        <th scope="col" className="py-1 px-7 min-w-[300px] rounded-br-lg rounded-tr-lg">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                Total Outstanding
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'TOTAL_OUTSTANDING_RS+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'TOTAL_OUTSTANDING_RS+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'TOTAL_OUTSTANDING_RS+asc') {
                                                                setsortType('TOTAL_OUTSTANDING_RS+desc');
                                                            } else if (sortType === 'TOTAL_OUTSTANDING_RS+desc') {
                                                                setsortType('TOTAL_OUTSTANDING_RS+asc');
                                                            } else {
                                                                setsortType('TOTAL_OUTSTANDING_RS+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {particularCustomerList.length > 0 && particularCustomerList.map((item) => (
                                        <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                            <td
                                                className="text-sm font-normal text-[#090406] py-1 px-7 sticky left-0 flex justify-center items-center pt-4"
                                                style={{
                                                    background: 'rgba(255, 255, 255, 0.45)',
                                                    backdropFilter: 'blur(5.5px)',
                                                }}
                                            >
                                                {item?.CUSTOMER_NAME}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-1 px-7 text-center">
                                                {item?.CUSTOMER_CODE}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-1 px-7">
                                                {item?.GST_INVOICE_NUMBER}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-1 px-7">
                                                {item?.GST_INVOICE_DATE !== null ? moment(item?.GST_INVOICE_DATE).format('DD-MMM-YYYY, HH:mm:ss') : '-'}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-1 px-7">
                                                {item?.UNIT}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-1 px-7">
                                                {item?.CLASS}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-1 px-7">
                                                {item?.AR_NUMBER}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-1 px-7">
                                                {moment(item?.AR_DATE).format('DD-MMM-YYYY, HH:mm:ss')}
                                            </td>
                                            <td className="text-sm font-normal more-lines text-[#090406] text-center py-1 px-7">
                                                {item?.DESCRIPTION}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-end py-1 px-7">
                                                {PriceHandler(item?.TOTAL_OUTSTANDING_RS)}
                                            </td>
                                        </tr>

                                    ))}

                                </tbody>
                            </table>
                        </div>

                    )}
                    {particularCustomerList.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            List={particularCustomerList}
                            currentPage={currentPage}
                            totalPage={totalPage}
                        />
                    )}
                    {viewFilterModal && (
                        <ViewCustomerFilterModal
                            viewFilterModal={viewFilterModal}
                            setViewFilterModal={setViewFilterModal}
                            selected={selected}
                            setselected={setselected}
                            viewCustomerFilter={viewCustomerFilter}
                            setViewCustomerFilter={setViewCustomerFilter}
                            // Filter={Filter}
                            // setFilter={setFilter}
                            handleFilter={handleFilter}
                            filterValue={filterValue}
                            setfilterValue={setfilterValue}
                            SetSuccessMessage={SetSuccessMessage}
                        />
                    )}
                    {emptyData && (
                        <EmptyScreen
                            search="yes"
                            text="no Outstanding Invoice Report"
                            buttonRequired={false}
                            all={debouncedSearch.length > 0 ? 'under searched term' : 'found'}
                        />
                    )}

                </div>
            )}

        </div>
    );
}

export default ViewCustomerOutstandingInvoice;
